import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "admin/announcement"
const options = {role: ROLE.SUPER_ADMIN};


export const sendEmailAnnouncement = async (values) => {
    return await axiosInstance(options).post(`${path}/send-mail`, values);
}
export const sendNotificationAnnouncement = async (values) => {
    return await axiosInstance(options).post(`${path}/send-notification`, values);
}